exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "footer.footer {\n  text-align: center;\n  padding: 30px 0;\n  margin-top: 70px;\n  border-top: 1px solid #E5E5E5;\n}\n", "", {"version":3,"sources":["/usr/src/braincubate-api/client/components/footer/footer.less"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;CAC/B","file":"footer.less","sourcesContent":["footer.footer {\n  text-align: center;\n  padding: 30px 0;\n  margin-top: 70px;\n  border-top: 1px solid #E5E5E5;\n}\n"],"sourceRoot":""}]);

// exports
